export default __webpack_public_path__ + "_/images/referrals/devices-1df7181c4a0489125f8acd2fc723f48ede67c8c48d620f398bcf609a04819893.png";